// extracted by mini-css-extract-plugin
export default {"blurredBackground":"logout_blurredBackground__ex+6-","container":"logout_container__R7AVt","form":"logout_form__wcXXJ"};